import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  mediaFadeRevealAnimation,
  paragraphRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const productDetailHeroRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const title = selector('[data-motion-title]')[0]
  const subtitle = selector('[data-motion-subtitle]')[0]
  const label = selector('[data-motion-label]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = mediaFadeRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0.1)
  }

  let subtitleAnimation: SharedAnimation
  if (subtitle) {
    subtitleAnimation = paragraphRevealAnimation(subtitle, reverse)
    timeline.add(subtitleAnimation.timeline, 0.1)
  }

  let labelAnimation: SharedAnimation
  if (label) {
    labelAnimation = fadeRevealAnimation(label)
    timeline.add(labelAnimation.timeline, 0.3)
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = fadeRevealAnimation(paragraph)
    timeline.add(paragraphAnimation.timeline, 0.4)
  }

  return () => {
    timeline.kill()

    mediaAnimation?.revert()
    titleAnimation?.revert()
    subtitleAnimation?.revert()
    paragraphAnimation?.revert()
    labelAnimation?.revert()
  }
}
